// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__o_pS1","unreadBadge":"styles_unreadBadge__W3yCD","modalContent":"styles_modalContent__E_h2g","modal":"styles_modal__2xnuX"};